import axios from "axios";
import { endpoints } from "../_config";

type RemainingEmailCountAPIResponse = {
  monthlyLimit: number;
  dailyLimit: number;
  monthlyLimitReset: Date;
  dailyLimitReset: Date;
};

class CommunityPlanAccessService {
  /**
   * get remaining email count
   * @param {*} postId
   * @returns
   */
  static async getRemainingEmailCount(
    communityId: String
  ): Promise<RemainingEmailCountAPIResponse> {
    return axios
      .get(endpoints.communityPlanAccess.getRemainingMailCount(communityId))
      .then((response) => response.data);
  }
}

export { CommunityPlanAccessService };
